import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'translations';
import Lightbox from 'mz-ui-kit/core/Lightbox';
import Button from 'mz-ui-kit/core/Button';
import LoadingSpinner from 'mz-ui-kit/core/LoadingSpinner';
import {
  setTermsAndConditions,
  getTermsAndConditions,
} from 'app/actions/book-trip';
import { LightboxWrapper, LoadingWrapper, ButtonWrapper } from './elements';

const messages = {
  title: { id: 'BOOK_TRIP.TERMS_AND_CONDITIONS' },
  close: { id: 'CLOSE' },
  error: { id: 'SEARCH_RESULTS.ERROR_MESSAGE' },
};

const TermsAndConditionsLightbox = ({ termsOfServiceURL, onClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(true);
  const termsAndConditions = useSelector(
    (state) => state.bookTrip.termsAndConditions
  );

  React.useEffect(() => {
    dispatch(getTermsAndConditions(termsOfServiceURL))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));

    return () => dispatch(setTermsAndConditions({}));
  }, []);

  return (
    <Lightbox
      title={<FormattedMessage {...messages.title} />}
      showed={true}
      onClose={onClose}
      render={() => (
        <LightboxWrapper>
          {loading ? (
            <LoadingWrapper>
              <LoadingSpinner size="large" />
            </LoadingWrapper>
          ) : (
            termsAndConditions.terms || <FormattedMessage {...messages.error} />
          )}
          <ButtonWrapper>
            <Button onClick={onClose}>
              <FormattedMessage {...messages.close} />
            </Button>
          </ButtonWrapper>
        </LightboxWrapper>
      )}
    />
  );
};

export default TermsAndConditionsLightbox;
